module.exports = __webpack_public_path__ + "static/media/Profile_Picture_Upload_Icon.a37549bd.svg";